import { makeAutoObservable } from 'mobx';
import { addTagToBook, deleteTagFromBook, loadBooks, saveBookUrl } from '../services/api';

class BooksStore {
  userStore;
  books = [];
  filters = {};
  order = {};
  currentPage = 1;
  totalBooks = 0;
  limit = 0;
  isLoading = false;
  pages = {
    first: '',
    last: '',
    next: '',
    prev: '',
    total: 0,
    current: 0,
  };

  constructor(userStore) {
    makeAutoObservable(this);
    this.userStore = userStore;
  }

  setIsLoading(value) {
    this.isLoading = value;
  }

  async setFilters({bookId, title, author, isbn, showNoMainBook, showOnlyWantToRead, showOnlyAlreadyRead, showOnlyEnabled, tagsAdmin, mainBookId}) {
    this.sort = {};
    this.currentPage = 1;
    this.filters = { bookId, title, author, isbn, showNoMainBook, showOnlyWantToRead, showOnlyAlreadyRead, showOnlyEnabled, tagsAdmin, mainBookId: mainBookId ?? this.filters.mainBookId };
    await this.load();
  }

  async setOrder(order, sort) {
    this.order = {order, sort};
    await this.load();
  }

  async setPage(page) {
    this.currentPage = page;
    await this.load();
  }

  async addTag(book, tag) {
    this.isLoading = true;
    try {
      await addTagToBook(this.userStore.token, book.book_id, tag.id);
      if (!book.book) {
        book.book = { admin_tags: [] };
      }
      if (!book.book.admin_tags) {
        book.book.admin_tags = [];
      }
      if (!book.book.admin_tags.some(t => t.id === tag.id)) {
        book.book.admin_tags.push(tag);
      }
      return true;
    } catch (error) {
      console.error('Error adding tag:', error);
      return false;
    } finally {
      this.isLoading = false;
    }
  }

  async removeTag(book, tag) {
    this.isLoading = true;
    try {
      await deleteTagFromBook(this.userStore.token, book.book_id, tag.id);
      if (book.book?.admin_tags) {
        const index = book.book.admin_tags.findIndex(t => t.id === tag.id);
        if (index !== -1) {
          book.book.admin_tags.splice(index, 1);
        }
      }
      return true;
    } catch (error) {
      console.error('Error removing tag:', error);
      return false;
    } finally {
      this.isLoading = false;
    }
  }

  async load() {
    this.isLoading = true;
    const response = await loadBooks(
      this.currentPage,
      this.filters,
      this.order,
      this.userStore.token
    );

    this.pages.first = response.data.data.first_page;
    this.pages.last = response.data.data.last_page;
    this.pages.next = response.data.data.next_page;
    this.pages.prev = response.data.data.prev_page;
    this.pages.total = response.data.data.total_pages;
    this.pages.current = response.data.data.current_page - 1;
    this.totalBooks = response.data.data.total;
    this.limit = response.data.data.limit;
    this.books = response.data.data.data;

    this.order = {order: response.data.data.ordered_by, sort: response.data.data.sorted};

    this.isLoading = false;
  }

  async loadAll() {
    this.isLoading = true;
    const all = [];
    let page = 1;
    let totalPages = 1;

    do {
      const response = await loadBooks(page, this.filters, this.order, this.userStore.token, 100);
      all.push(...response.data.data.data);
      totalPages = response.data.data.total_pages;
      this.totalBooks = response.data.data.total;
      this.order = { order: response.data.data.ordered_by, sort: response.data.data.sorted };
      page += 1;
    } while (page <= totalPages);

    this.books = all;
    this.limit = all.length;
    this.pages = { first: '', last: '', next: '', prev: '', total: 1, current: 0 };
    this.isLoading = false;
  }

  async saveUrl(id, url) {
    try {
      await saveBookUrl(id, url, this.userStore.token);
      return true;
    } catch (e) {
      return false;
    }
  }
}

export default BooksStore;
